import ProtectedRoute from '@/components/protected-route'
import { AppAgency } from '@/pages/AppAgency.tsx'
import LoginPageAgency from '@/pages/login/LoginPageAgency.tsx'
import { ConfigProvider, Flex } from 'antd'
import { loginApi } from 'common/api/entitiesApi.tsx'
import { useUserContext } from 'common/context/UserContext.tsx'
import { buildThemeFromPalette } from 'common/util/colorPalette.ts'
import { isAuthenticated, setLoggedUserProps } from 'common/util/Util.tsx'
import { useEffect, useMemo, useState } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'

import 'common/pages/style.css'

const MainAgency = () => {
  const location = useLocation()
  const { setUser, colorPalette, customizationLoaded } = useUserContext()
  const navigateTo = useNavigate()
  const [appReady, setAppReady] = useState(false)

  useEffect(() => {
    let isMounted = true

    const init = async () => {
      const urlParams = new URLSearchParams(location.search)
      const tokenParam = urlParams.get('token')

      if (tokenParam) {
        const success = await loginApi.loginByToken(tokenParam)
        if (success) {
          await setLoggedUserProps(setUser)
        }
        navigateTo('/', { replace: true })
      } else if (isAuthenticated()) {
        await setLoggedUserProps(setUser)
      }

      if (isMounted) {
        setAppReady(true)
      }
    }

    init()

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  const theme = useMemo(() => buildThemeFromPalette(colorPalette), [colorPalette])

  if (!customizationLoaded || !appReady) {
    return (
      <Flex
        justify="center"
        align="center"
        style={{ minHeight: '100vh', backgroundColor: colorPalette['--color-grey-4'] }}
      />
    )
  }

  return (
    <ConfigProvider theme={theme}>
      <Flex
        justify="center"
        align="center"
        style={{ minHeight: '100vh', backgroundColor: colorPalette['--color-grey-4'] }}
      >
        <Routes>
          <Route path="/login" element={<LoginPageAgency />} />
          <Route path="/*" element={<ProtectedRoute />}>
            <Route path="*" element={<AppAgency />} />
          </Route>
        </Routes>
      </Flex>
    </ConfigProvider>
  )
}

export default MainAgency